export const creditScoreRateRender = (e) => {
    const csr = e.data.creditScoreRate;

    if (csr === null || csr === undefined || csr === '') {
        return 'TBD';
    }

    return csr;
};
